import React from "react";
import { useFormik } from "formik";

import {
  fetchPartnerCredentials,
  savePartnerCredentials,
} from "../../services/partner.service.ts";
import SaveCredentialsSchema from "../../validation/schemas/SaveCredentialsSchema.ts";

import CustomInput from "../formik/CustomInput.tsx";
import Loader from "../Loader.tsx";
import { notification } from "../../utils/Notifications.tsx";
import { REACT_APP_APP_URL } from "../../config/app-settings.js";

const GetCredentials = ({ name, id, closeFn, colaborador }) => {
  const [loading, setLoading] = React.useState(true);
  const [credentials, setCredentials] = React.useState<{
    email: string;
    password?: string;
    hasCredentials?: boolean;
  } | null>(null);

  const issueCredentials = async () => {
    const email = `${colaborador?.curp.toLowerCase().trim()}@chiliguajili.com`;
    const issued = await savePartnerCredentials({
      email: credentials?.email || email,
      partnerId: id,
    });
    formik.setFieldValue("email", issued.email);
    formik.setFieldValue("password", issued.password);
    setCredentials(issued);
  };

  const fetchCredentials = async () => {
    try {
      const existingCredentials = await fetchPartnerCredentials(id);
      if (existingCredentials?.email) {
        formik.setFieldValue("email", existingCredentials.email);
        formik.setFieldValue("password", "");
        setCredentials({
          email: existingCredentials.email,
          hasCredentials: true,
        });
      } else {
        await issueCredentials();
      }
    } catch (error) {
      setCredentials(null);
      if (error.message === "No existe un usuario") {
        await issueCredentials();
        return;
      }

      notification(
        "Error",
        "Ocurrió un error al obtener sus credenciales",
        "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { email: "", password: "" },
    validationSchema: SaveCredentialsSchema,
    onSubmit: () => {},
  });

  React.useEffect(() => {
    fetchCredentials();
  }, []);

  return (
    <React.Fragment>
      <Loader isLoading={loading} />
      <div className="d-flex flex-column">
        <CustomInput
          formik={formik}
          field="email"
          label="Correo electrónico"
          placeholder="Correo electrónico"
          sm={8}
          smLabel={4}
          disabled
        />
        <CustomInput
          formik={formik}
          field="password"
          label="Contraseña"
          placeholder={
            credentials?.hasCredentials && !credentials.password
              ? "No se puede consultar. Genera una nueva."
              : "Contraseña"
          }
          sm={8}
          smLabel={4}
          disabled
        />
        <div className="mx-auto mb-3">
          {credentials?.hasCredentials && !credentials.password && (
            <button
              type="button"
              className="btn btn-outline-secondary me-2"
              onClick={() => issueCredentials()}
            >
              Generar nueva contraseña
            </button>
          )}
          <button
            className="btn btn-amarillo ms-3"
            type="button"
            onClick={() => {
              if (!formik.values.password) {
                notification(
                  "Sin contraseña visible",
                  "La contraseña anterior no se puede recuperar. Genera una nueva para copiarla.",
                  "warning"
                );
                return;
              }
              notification(
                "Copiado",
                "Accesos copiada al portapapeles",
                "success"
              );
              navigator.clipboard.writeText(
                `Para acceder a tu cuenta en Chiliguajili, utiliza los siguientes datos en ${REACT_APP_APP_URL}/login : \n\n` +
                  `Correo electrónico: ${formik.values.email}\n` +
                  `Contraseña: ${formik.values.password}` +
                  "\n\n¡Gracias por ser parte de Chiliguajili!"
              );
            }}
          >
            <i className="fa-solid fa-copy"></i> Copiar al portapapeles
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button
          className="btn btn-azul"
          onClick={() => {
            if (!loading && !credentials) {
              return formik.handleSubmit();
            }
            closeFn();
          }}
        >
          {!loading && !credentials ? "Generar claves" : "Aceptar"}
        </button>
      </div>
    </React.Fragment>
  );
};

export default GetCredentials;
